import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { CITIES } from "@/data";

const CoverageChecker = () => {
  const [q, setQ] = useState("");
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();
  const matches = q.trim()
    ? CITIES.filter((c) => c.name.toLowerCase().includes(q.trim().toLowerCase())).slice(0, 6)
    : [];

  const submit = (e) => {
    e.preventDefault();
    if (matches.length) navigate(`/locations/${matches[0].slug}`);
    else navigate("/locations");
  };

  return (
    <div className="relative border border-[#1C2027] bg-[#10131A] p-6 sm:p-8" data-testid="coverage-checker">
      <h2 className="font-condensed text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">Do we cover your area?</h2>
      <p className="mt-2 text-sm leading-relaxed text-[#9BA1AB]">
        Enter your Welsh town or city and jump straight to your local security pages — 35+ Wales locations, 17 specialist services, one standard.
      </p>
      <form onSubmit={submit} className="mt-5 flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#9BA1AB]" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setTimeout(() => setFocused(false), 150)}
            placeholder="e.g. Cardiff, Wrexham, Aberystwyth…"
            data-testid="coverage-input"
            className="w-full border border-[#1C2027] bg-[#0A0C10] py-3 pl-10 pr-3 text-sm text-white placeholder:text-white/30 focus:border-[#F5A800] focus:outline-none"
          />
        </div>
        <button type="submit" data-testid="coverage-submit" className="bg-[#F5A800] px-5 text-sm font-bold uppercase tracking-[0.14em] text-[#0A0C10] transition-colors duration-300 hover:bg-white">
          Check
        </button>
      </form>
      {focused && matches.length > 0 && (
        <ul className="absolute left-6 right-6 top-full z-20 -mt-px border border-[#1C2027] bg-[#10131A] shadow-2xl" data-testid="coverage-suggestions">
          {matches.map((c) => (
            <li key={c.slug}>
              <button
                type="button"
                onMouseDown={() => navigate(`/locations/${c.slug}`)}
                data-testid={`coverage-suggestion-${c.slug}`}
                className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-white/80 transition-colors hover:bg-[#F5A800]/10 hover:text-[#F5A800]"
              >
                <MapPin className="h-4 w-4 text-[#F5A800]" />
                Security Services {c.name}
                <span className="ml-auto text-[10px] uppercase tracking-[0.2em] text-white/40">{c.county}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CoverageChecker;
